var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopilotAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 14.25H15.25V18C15.25 18.4125 14.9125 18.75 14.5 18.75C14.0875 18.75 13.75 18.4125 13.75 18V14.25H10C9.5875 14.25 9.25 13.9125 9.25 13.5C9.25 13.0875 9.5875 12.75 10 12.75H13.75V9C13.75 8.5875 14.0875 8.25 14.5 8.25C14.9125 8.25 15.25 8.5875 15.25 9V12.75H19C19.4125 12.75 19.75 13.0875 19.75 13.5C19.75 13.9125 19.4125 14.25 19 14.25Z",
    fill: "#1777CF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00805 10.3633L4.96818 12.8794C4.73928 13.4402 4.00679 13.4402 3.77789 12.8794L2.73802 10.3633L0.448999 9.2202C-0.0611253 8.96139 -0.0611254 8.16341 0.448999 7.91179L2.73802 6.76873L3.77789 4.25256C4.01333 3.69181 4.73928 3.69181 4.96818 4.25256L6.00805 6.76873L8.29707 7.91179C8.8072 8.17059 8.8072 8.96858 8.29707 9.2202L6.00805 10.3633ZM10.6123 5.69037L10.0956 4.43228L8.95108 3.86435C8.69601 3.73494 8.69601 3.33955 8.95108 3.21014L10.0956 2.64221L10.6123 1.37693C10.73 1.09656 11.0897 1.09656 11.2074 1.37693L11.7241 2.63502L12.8751 3.20295C13.1302 3.33236 13.1302 3.72776 12.8751 3.85716L11.7306 4.42509L11.2139 5.69037C11.0962 5.97074 10.73 5.97074 10.6123 5.69037Z",
    fill: "#1777CF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopilotAdd);
export default __webpack_public_path__ + "static/media/copilot-add.d2f713130aeff1a1b30ffdc7441fbd21.svg";
export { ForwardRef as ReactComponent };